import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../helpers/reducerRegistry'
import { COMPARE_TYPE } from '../constant'
import { getDataTable, getIds } from '../helper'
import { getFdiDomestic, getLargeSme, getListedLarge } from './thunk'

const slice = createSlice({
  name: 'industryAnalysis/sectorPerformance',
  initialState: {
    isLoading: false,
    compareVal: COMPARE_TYPE.FDI_DOMESTIC,
    data: {
      [COMPARE_TYPE.FDI_DOMESTIC]: {},
      [COMPARE_TYPE.LARGE_SME]: {},
      [COMPARE_TYPE.LISTED_LARGE]: {},
    },
    dataTable: {
      [COMPARE_TYPE.FDI_DOMESTIC]: {
        size: {
          ids: [],
          data: [],
        },
        noc: {
          ids: [],
          data: [],
        },
        ratio: {
          ids: [],
          data: [],
        },
      },
      [COMPARE_TYPE.LARGE_SME]: {
        size: {
          ids: [],
          data: [],
        },
        noc: {
          ids: [],
          data: [],
        },
        ratio: {
          ids: [],
          data: [],
        },
      },
      [COMPARE_TYPE.LISTED_LARGE]: {
        size: {
          ids: [],
          data: [],
        },
        noc: {
          ids: [],
          data: [],
        },
        ratio: {
          ids: [],
          data: [],
        },
      },
    },
  },
  reducers: {
    changeCompareVal: (state, action) => {
      state.compareVal = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFdiDomestic.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getFdiDomestic.fulfilled, (state, { payload }) => {
      state.isLoading = false
      state.data[COMPARE_TYPE.FDI_DOMESTIC] = payload

      const defaultIndustry = payload?.defaultIndustry || {}
      const comparingIndustry = payload?.comparingIndustry || {}

      const normalizeDefault = (defaultData = [], comparingData = []) => {
        if (defaultData?.length) return defaultData
        return (
          comparingData?.map((item) => ({
            vsicId: payload?.DefaultVSICId,
            typeGroup: item.typeGroup,
            type: item.type,
          })) || []
        )
      }

      const buildSection = (key) => {
        const comparing = comparingIndustry?.[key] || []
        const isComparingExist = Object.keys(comparingIndustry).length > 0
        const defaultFixed = normalizeDefault(defaultIndustry?.[key], comparing)
        const ids = getIds(comparing.length ? comparing : defaultFixed)
        return {
          ids,
          data: getDataTable(
            ids,
            defaultFixed,
            comparing,
            isComparingExist,
            payload?.DefaultVSICId,
            payload?.CompareVSICId,
          ),
        }
      }
      state.dataTable[COMPARE_TYPE.FDI_DOMESTIC] = {
        size: buildSection('size'),
        noc: buildSection('noc'),
        ratio: buildSection('ratio'),
      }
    })
    builder.addCase(getFdiDomestic.rejected, (state, action) => {
      state.isLoading = action.payload.loading
    })

    builder.addCase(getLargeSme.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getLargeSme.fulfilled, (state, { payload }) => {
      state.isLoading = false
      state.data[COMPARE_TYPE.LARGE_SME] = payload

      const defaultIndustry = payload?.defaultIndustry || {}
      const comparingIndustry = payload?.comparingIndustry || {}

      const normalizeDefault = (defaultData = [], comparingData = []) => {
        if (defaultData?.length) return defaultData
        return (
          comparingData?.map((item) => ({
            vsicId: payload?.DefaultVSICId,
            typeGroup: item.typeGroup,
            type: item.type,
          })) || []
        )
      }

      const buildSection = (key) => {
        const comparing = comparingIndustry?.[key] || []
        const isComparingExist = Object.keys(comparingIndustry).length > 0
        const defaultFixed = normalizeDefault(defaultIndustry?.[key], comparing)
        const ids = getIds(comparing.length ? comparing : defaultFixed)
        return {
          ids,
          data: getDataTable(
            ids,
            defaultFixed,
            comparing,
            isComparingExist,
            payload?.DefaultVSICId,
            payload?.CompareVSICId,
          ),
        }
      }

      state.dataTable[COMPARE_TYPE.LARGE_SME] = {
        size: buildSection('size'),
        noc: buildSection('noc'),
        ratio: buildSection('ratio'),
      }
    })
    builder.addCase(getLargeSme.rejected, (state, action) => {
      state.isLoading = action.payload.loading
    })

    builder.addCase(getListedLarge.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getListedLarge.fulfilled, (state, { payload }) => {
      state.isLoading = false
      state.data[COMPARE_TYPE.LISTED_LARGE] = payload

      const defaultIndustry = payload?.defaultIndustry || {}
      const comparingIndustry = payload?.comparingIndustry || {}

      const normalizeDefault = (defaultData = [], comparingData = []) => {
        if (defaultData?.length) return defaultData
        return (
          comparingData?.map((item) => ({
            vsicId: payload?.DefaultVSICId,
            typeGroup: item.typeGroup,
            type: item.type,
          })) || []
        )
      }

      const buildSection = (key) => {
        const comparing = comparingIndustry?.[key] || []
        const isComparingExist = Object.keys(comparingIndustry).length > 0
        const defaultFixed = normalizeDefault(defaultIndustry?.[key], comparing)
        const ids = getIds(comparing.length ? comparing : defaultFixed)
        return {
          ids,
          data: getDataTable(
            ids,
            defaultFixed,
            comparing,
            isComparingExist,
            payload?.DefaultVSICId,
            payload?.CompareVSICId,
          ),
        }
      }
      state.dataTable[COMPARE_TYPE.LISTED_LARGE] = {
        size: buildSection('size'),
        noc: buildSection('noc'),
        ratio: buildSection('ratio'),
      }
    })
    builder.addCase(getListedLarge.rejected, (state, action) => {
      state.isLoading = action.payload.loading
    })
  },
})

register(slice.name, slice.reducer)

export const selectLoading = (state) => state[slice.name].isLoading
export const selectData = (state) => state[slice.name].data
export const selectCompareVal = (state) => {
  return state[slice.name].compareVal
}
export const selectDataTable = (compareVal, type) => (state) => {
  return (
    state[slice.name].dataTable?.[compareVal]?.[type] || { ids: [], data: [] }
  )
}
export const selectRowGroup = (compareVal, type, rowGroupId) => (state) => {
  return (
    state[slice.name].dataTable?.[compareVal]?.[type]?.data?.[rowGroupId] || []
  )
}
export const selectCellData =
  (compareVal, type, rowId, index, colId) => (state) => {
    return state[slice.name].dataTable?.[compareVal]?.[type]?.data?.[rowId]?.[
      index
    ]?.[colId]
  }

export const { changeCompareVal } = slice.actions
